import { FlujoAlternoBean } from "./flujo_alterno";
import { Base } from "./model/core/base.model";
import { ProductosSalidaBean } from "./productosSalida";

export class CasoDeUsoBean extends Base{
    id: number;
    descripcion: string; 
    nombre: string;
    actores: string; 
    precondiciones: string;
    flujo_primario: number; 
    pos_condiciones: string;
    reglas_negocio: string; 
    premisas: string; 
    fecha_registro: Date;

    id_proyecto:string;
	nombre_responsable:string;
	prioridad: number;
	clase:string;
	tipo:string;
	estatus:string;
    responsable: number;

    flujosAlternos:FlujoAlternoBean [] = [];
    productosSalida: ProductosSalidaBean [] = [];
}